export default "__VITE_ASSET__ClYAKObp__"